/*
 * @Description: 
 * @Author: shenkaiyao
 * @Date: 2020-09-24 10:26:14
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2021-01-19 10:16:38
 */
import Upload from './upload';

export default Upload